import {
  money_square_icon,
  signed_square_icon,
  wallet_square_icon,
  calendar_square_icon,
  avis_square_icon,
  investigation_square_icon,
} from '../utils/images';

const expertActivityImage = {
  0: money_square_icon,
  1: calendar_square_icon,
  2: calendar_square_icon,
  3: signed_square_icon,
  4: money_square_icon,
};

const clientActivityImage = {
  '-1': wallet_square_icon,
  0: money_square_icon,
  1: calendar_square_icon,
  2: calendar_square_icon,
  3: signed_square_icon,
  4: avis_square_icon,
  5: signed_square_icon,
  6: investigation_square_icon,
};

export const CommonActivityImage = {
  expert: expertActivityImage,
  client: clientActivityImage,
};

const expertActivityTitle = {
  0: "Client en attente d'acceptation",
  1: 'En attente de confirmation du client',
  2: 'Rendez-vous programmé pour le {{date}}',
  3: 'Avez-vous signé un contrat ?',
  4: 'Prochaine commission à payer au plus tard le {{commissionDate}}',
};

const clientActivityTitle = {
  '-1': 'Sélectionnez un expert',
  0: "En attente d'acceptation",
  1: "En attente d'acceptation d'un rendez-vous",
  2: 'Rendez-vous programmé pour le {{date}}',
  3: 'Signature de contrat',
  4: 'Donnez votre avis',
  5: 'Signature de contrat',
  6: 'Investigation en cours',
};

export const CommonActivityTitle = {
  expert: expertActivityTitle,
  client: clientActivityTitle,
};

const expertActivityDetail = {
  0: "Vous avez des clients en attente d'acceptation",
  1: 'Vous serez notifié quand le client aura sélectionné un rendez-vous',
  2: 'Rendez-vous programmé avec votre client {{client}}',
  3: 'Signez la lettre de mission pour valider la procédure',
  4: '',
};

const clientActivityDetail = {
  '-1': 'En acceptant un devis, vous serez mis en relation avec un expert',
  0: "Veuillez patienter le temps que l'expert valide votre demande",
  1: "Vous avez 5 rendez-vous en attente d'acceptation",
  2: 'Rendez-vous programmé avec votre expert {{expert}}',
  3: 'Votre expert a signé le contrat. Veuillez le signer à votre tour',
  4: 'Donnez votre avis',
  5: 'Veuillez indiquer si vous avez contracté avec {{expert}}',
  6: 'Les signatures ne concordent pas, une enquête est en cours',
};

export const CommonActivityDetail = {
  expert: expertActivityDetail,
  client: clientActivityDetail,
};

const clientStatusDetail = {
  '-2': 'Contrat non signé',
  '-1': 'Refusé',
  0: "En attente d'acceptation de l'expert",
  1: "En attente d'acceptation de rdv",
  2: 'Validé',
  3: 'Signez la lettre de mission',
  4: 'Validé',
  7: 'Investigation',
};

const expertStatusDetail = {
  '-2': 'Contrat non signé',
  '-1': 'Refusé',
  0: "En attente d'acceptation de votre part",
  1: 'En attente de confirmation du client',
  2: 'Validé',
  3: 'Signez la lettre de mission',
  4: 'Validé',
  7: 'Investigation',
};

export const waitingStatusDetail = {
  expert: expertStatusDetail,
  client: clientStatusDetail,
};

export const waitingStatusClasses = {
  '-2': 'red',
  '-1': 'red',
  0: 'yellow',
  1: 'yellow',
  2: 'green',
  3: 'pink',
  4: 'green',
  7: 'yellow',
};

export const stateProgression = {
  0: 'Sélectionnez un expert',
  1: "En attente d'acceptation",
  2: "En attente d'acceptation d'un rendez-vous",
  3: 'En attente du rendez-vous réalisé',
  4: 'Signature de contrat',
  5: 'Donnez votre avis',
};
